import classNames from 'classnames';
import * as React from 'react';
import type { ReactNode } from 'react';
import { useTheme } from '../../Layouts/Theme/Context/ThemeContextProvider';
import { LinkType } from '../Link/LinkType.csharp';
import { Link } from '~/Partials/Link/Link';
import type { LinkCardVariant } from '~/Partials/LinkCard/LinkCardVariant.csharp';
import { useClickProxyAllowingTextSelection } from '~/Utils/Hooks/useClickProxyAllowingTextSelection';
import styles from './LinkCard.module.css';

export interface LinkCardProps {
    variant: LinkCardVariant;
    linkUrl: string;
    topBanner: string | ReactNode;
    cardLabel: string;
    bottomBanner: string | ReactNode;
    className?: string;
}

export const LinkCard: React.FC<React.PropsWithChildren<LinkCardProps>> = props => {
    const { variant, topBanner, cardLabel, bottomBanner, linkUrl, className } = props;
    const { clickableRef, onProxyMouseDown, onProxyMouseUp } = useClickProxyAllowingTextSelection<HTMLAnchorElement>();
    const theme = useTheme();
    const { withRoundedCorners } = theme;

    return (
        <div
            role="none"
            className={classNames(
                styles.LinkCard,
                styles[`Variant--${variant}`],
                withRoundedCorners && styles['Variant--rounded'],
                className
            )}
            onMouseDown={onProxyMouseDown}
            onMouseUp={onProxyMouseUp}
            tabIndex={-1}
        >
            <h3 className={styles.Header}>
                <Link href={linkUrl} type={LinkType.Clear} ref={clickableRef} className={styles.Link}>
                    {cardLabel}
                </Link>
            </h3>
            <div className={styles.Top}>{topBanner}</div>
            <div className={styles.Bottom}>{bottomBanner}</div>
        </div>
    );
};
